
import React, { useState, useEffect, useRef } from 'react';
import { Button, Dropdown } from "primereact";
import { Link } from 'react-router-dom';
import classNames from 'classnames';


export const AppTopbar = (props) => {
    const [selectedCountry, setSelectedCountry] = useState(props.lingua);
  
    const countries = [
        { name: 'Italiano', code: 'IT' },
        { name: 'English', code: 'UK' },
    
    ];
    
    const countryOptionTemplate = (option) => {
        return (
            <div className="country-item">
                <img alt={option.name} src="images/flag_placeholder.png" onError={(e) => e.target.src = 'https://www.primefaces.org/wp-content/uploads/2020/05/placeholder.png'} className={`flag flag-${option.code.toLowerCase()}`} />
                <div>{option.name}</div>
            </div>
        );
    }
    
    const onCountryChange = (e) => {

        setSelectedCountry(e.value);
        props.onLanguageClick(e.value.code);
        document.getElementById("aaGG").innerText=e.value.code;
       
    }
    const onClickita = (e) => {
        setSelectedCountry( { name: 'Italiano', code: 'IT' });
        props.onLanguageClick('IT');
        document.getElementById("aaGG").innerText='IT';
       
    }

    const onClickeng = (e) => {
        setSelectedCountry( { name: 'English', code: 'UK' });
        props.onLanguageClick('UK');
        document.getElementById("aaGG").innerText='UK';
       
    }

    const selectedCountryTemplate = (option, props) => {
        if (option) {
            return (
                <div className="country-item country-item-value">
                    <img alt={option.name} src="images/flag_placeholder.png" onError={(e) => e.target.src = 'https://www.primefaces.org/wp-content/uploads/2020/05/placeholder.png'} className={`flag flag-${option.code.toLowerCase()}`} />
                    <div>{option.name}</div>
                </div>
            );
        }

        return (
            <span>
                {props.placeholder}
            </span>
        );
    }
    return (
        <div className="layout-topbar">
           <div className="col-12 flex justify-content-between">
           <div>
           <div id="aaGG" style={{width:'1px',maxHeight:'1px'}}> </div>
           <img style={{maxHeight:'40pt'}} src="assets/layout/images/thumbnail.png" alt="logo"/>
        
           </div>
           
            {(sessionStorage.getItem("ruoloid") && sessionStorage.getItem("ruoloid")!=2?
            <button type="button" className="p-link"  onClick={props.onToggleMenuClick}>
                <i className="pi pi-bars"/>
            </button>:"")}
    
               
            <div className="flex justify-content-start">
            {(sessionStorage.getItem("ruoloid")?
           <button type="button" className="p-link layout-topbar-menu-button"  onClick={props.onMobileTopbarMenuClick}>
                <i className="pi pi-ellipsis-v" />
            </button>:"")}

            {(sessionStorage.getItem("ruoloid") && sessionStorage.getItem("ruoloid")!=2?
           <Dropdown id="linguaPP" value={selectedCountry} options={countries} 
            onChange={onCountryChange}
             optionLabel="name" placeholder="Select a Country"
                    valueTemplate={selectedCountryTemplate} itemTemplate={countryOptionTemplate} />
                    :"")}
          
            </div>
           
            <div className="justify-content-end">
         {/*<Link to={'/dashboard'}>
                        <button className="p-link layout-topbar-button"  >
                               <i className="pi pi-home"/>
                        </button>
                     </Link>
                    */}                <button className="p-link layout-topbar-button" >
                        <Link to="/login">
                            <i className={(sessionStorage.getItem("isAutenticate")?"pi pi-sign-out":"pi pi-user")}/>
                            </Link>
                            </button>
                            {(!sessionStorage.getItem("ruoloid")?<><br/>
                            <a onClick={onClickita} style={{cursor:'pointer',color:'black', fontWeight:(selectedCountry.code=='IT'?'bold':'')}}
                            >Italiano</a>  | <a onClick={onClickeng} style={{cursor:'pointer',color:'black',fontWeight:(selectedCountry.code=='UK'?'bold':'')}}>English</a>
                            </>:<></>)}
               </div>
            </div>

      
        </div>
    );
}
